"use client";

import { ICMSConcurso, IPAGEDetalheConcursosAberto } from '@/services/types';
import React from 'react';
import InformacaoConcursoSection from './InformacaoConcursoSection';
import AnexosConcursoSection from './AnexosConcursoSection';
import ComunicadosConcursoSection from './ComunicadosConcursoSection';
import ResultadosConcursoSection from './ResultadosConcursoSection';


interface ConcursoDetalhesClientProps {
    concursoData: ICMSConcurso | null; 
    pageData: IPAGEDetalheConcursosAberto | null;   
}

const ConcursoDetalhesClient: React.FC<ConcursoDetalhesClientProps> = ({ concursoData,  }) => {
    console.log("[PAGE CLIENT] ConcursoDetalhesClient props:", { concursoData });
    // Usar o contexto do banner para atualizar as informações


    if (!concursoData) {
        return (
            <div className="flex justify-center items-center min-h-[400px]">
                <div className="text-center">
                    <div className="w-16 h-16 border-4 rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600 text-lg">Carregando detalhes da Concurso...</p>
                </div>
            </div>
        );
    }

    return (
        <>

            {/** info Concurso */}
            <InformacaoConcursoSection concurso={concursoData}/>

            {/** anexo section  list*/}
            {concursoData.session_anexo && <AnexosConcursoSection anexos={concursoData.session_anexo}/>}

            {/** session_comunicados section */}
            {
                concursoData.session_comunicados && <ComunicadosConcursoSection comunicado={concursoData.session_comunicados}/>
            }

            {/** resultado section */}
            {
                concursoData && <ResultadosConcursoSection concurso={concursoData} />
            }
        </>
    );
};

export default ConcursoDetalhesClient;